import { Shape, SpotShape, SpotShapeItem } from '../../../../types';

export const findSpotInGroup = (shape: Shape): Shape[] => {
  if (shape.type === 'spot') {
    return [shape];
  }

  if (shape.type === 'group' && shape.children) {
    return shape.children.flatMap(findSpotInGroup);
  }

  return [];
};

export const getAllSpots = (shapes: Shape[]) => {
  const spotShapes = shapes.flatMap(findSpotInGroup) as SpotShape[];
  const spotItems: SpotShapeItem[] = [];

  spotShapes.forEach((spotShape) => {
    spotItems.push(spotShape);
  });

  return spotItems;
};

export const getSpotUnderPoint = (
  stage: any,
  point: { x: number; y: number }
) => {
  const shape = stage.getIntersection(point);
  if (!shape) return null;

  // Find the root group (spot shape)
  let parent = shape.getParent();

  while (parent && !parent.attrs.id?.startsWith('spot-')) {
    parent = parent.getParent();
  }

  if (parent) {
    return parent.attrs.id?.replace('shape-', '');
  }

  return null;
};

export const getShapeUnderPoint = (
  stage: any,
  point: { x: number; y: number }
) => {
  const shape = stage.getIntersection(point);
  if (!shape) return null;

  // Find the root group (spot shape)
  let parent = shape;

  while (parent && !parent.attrs.id?.startsWith('shape-')) {
    parent = parent.getParent();
  }

  if (parent) {
    return parent.attrs.id?.replace('shape-', '');
  }

  return null;
};
